import { Button, Input, Label } from '@estac1/ui';
import type { UseQueryResult } from '@tanstack/react-query';
import { ALL, type AuditFacets } from './types.js';

interface FilterSelectProps {
  id: string;
  value: string;
  onChange: (v: string) => void;
  options: string[];
}

const FilterSelect = ({ id, value, onChange, options }: FilterSelectProps) => (
  <select
    id={id}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="h-9 w-full rounded border border-border bg-surface px-3 text-sm"
  >
    <option value={ALL}>Todos</option>
    {options.map((o) => (
      <option key={o} value={o}>
        {o}
      </option>
    ))}
  </select>
);

interface AuditFiltersProps {
  facets: UseQueryResult<AuditFacets>;
  actionFilter: string;
  entityFilter: string;
  actorFilter: string;
  idQuery: string;
  onActionFilter: (v: string) => void;
  onEntityFilter: (v: string) => void;
  onActorFilter: (v: string) => void;
  onIdQuery: (v: string) => void;
  entriesCount: number;
  hasNextPage: boolean;
  hasActiveFilter: boolean;
  onClearFilters: () => void;
}

export const AuditFilters = ({
  facets,
  actionFilter,
  entityFilter,
  actorFilter,
  idQuery,
  onActionFilter,
  onEntityFilter,
  onActorFilter,
  onIdQuery,
  entriesCount,
  hasNextPage,
  hasActiveFilter,
  onClearFilters,
}: AuditFiltersProps) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
    <div className="space-y-1">
      <Label htmlFor="audit-action">Ação</Label>
      <FilterSelect
        id="audit-action"
        value={actionFilter}
        onChange={onActionFilter}
        options={facets.data?.actions ?? []}
      />
    </div>
    <div className="space-y-1">
      <Label htmlFor="audit-entity">Entidade</Label>
      <FilterSelect
        id="audit-entity"
        value={entityFilter}
        onChange={onEntityFilter}
        options={facets.data?.entities ?? []}
      />
    </div>
    <div className="space-y-1">
      <Label htmlFor="audit-actor">Ator</Label>
      <FilterSelect
        id="audit-actor"
        value={actorFilter}
        onChange={onActorFilter}
        options={facets.data?.actors ?? []}
      />
    </div>
    <div className="space-y-1">
      <Label htmlFor="audit-id">ID</Label>
      <Input
        id="audit-id"
        placeholder="Buscar por ID"
        value={idQuery}
        onChange={(e) => onIdQuery(e.target.value)}
      />
    </div>
    <div className="flex flex-col gap-2 text-xs text-muted-fg sm:col-span-2 lg:col-span-4 sm:flex-row sm:items-center sm:justify-between">
      <span>
        {entriesCount} registro{entriesCount === 1 ? '' : 's'}
        {hasNextPage ? '+' : ''} {hasActiveFilter ? 'com os filtros' : 'carregados'}
      </span>
      {hasActiveFilter && (
        <Button variant="ghost" size="sm" onClick={onClearFilters}>
          Limpar filtros
        </Button>
      )}
    </div>
  </div>
);
